import { useEffect } from 'react';
import { initPlotter } from './plotter/plotter.esm.js';
import { PlotterLayout } from './components/PlotterLayout.jsx';

export default function App() {
  useEffect(() => {
    initPlotter();
  }, []);
  return <PlotterLayout />;
}
